/**
 * Settings Page
 *
 * Company profile, team management, and account settings.
 * PURELY PRESENTATIONAL - basic settings UI placeholder.
 */

import { PageHeader } from '@/components/service-provider/PageHeader';

export function SettingsPage() {
  return (
    <div>
      <PageHeader
        title="Settings"
        description="Manage your company profile and preferences"
        breadcrumbs={[
          { label: 'Dashboard', href: '/provider/dashboard' },
          { label: 'Settings' },
        ]}
      />

      <div className="max-w-4xl">
        <div className="space-y-8">
          {/* Company Profile */}
          <section className="card">
            <div className="card-header">
              <h2 className="card-title">Company Profile</h2>
              <p className="text-sm text-neutral-600 mt-1">
                Update your company information and contact details
              </p>
            </div>
            <div className="card-content space-y-4">
              <div>
                <label
                  htmlFor="company-name"
                  className="block text-sm font-medium text-neutral-700 mb-2"
                >
                  Company Name
                </label>
                <input
                  type="text"
                  id="company-name"
                  className="input-field"
                  placeholder="Your Company Name"
                  disabled
                />
                <p className="text-xs text-neutral-500 mt-1">
                  Contact support to change your company name
                </p>
              </div>
            </div>
          </section>

          {/* Service Area */}
          <section className="card">
            <div className="card-header">
              <h2 className="card-title">Service Area</h2>
              <p className="text-sm text-neutral-600 mt-1">
                Counties where you provide waste management services
              </p>
            </div>
            <div className="card-content">
              <p className="text-sm text-neutral-600">
                Service area configuration coming soon in Phase 4.
              </p>
            </div>
          </section>

          {/* Notification Preferences */}
          <section className="card">
            <div className="card-header">
              <h2 className="card-title">Notifications</h2>
              <p className="text-sm text-neutral-600 mt-1">
                Choose how you want to be notified
              </p>
            </div>
            <div className="card-content space-y-3">
              <label className="flex items-start space-x-3">
                <input
                  type="checkbox"
                  className="mt-1 rounded border-neutral-300 text-primary-600 focus:ring-primary-500"
                  defaultChecked
                />
                <div>
                  <p className="text-sm font-medium text-neutral-700">
                    New Job Opportunities
                  </p>
                  <p className="text-xs text-neutral-500">
                    Get notified when new jobs match your service area
                  </p>
                </div>
              </label>
              <label className="flex items-start space-x-3">
                <input
                  type="checkbox"
                  className="mt-1 rounded border-neutral-300 text-primary-600 focus:ring-primary-500"
                  defaultChecked
                />
                <div>
                  <p className="text-sm font-medium text-neutral-700">
                    Bid Updates
                  </p>
                  <p className="text-xs text-neutral-500">
                    Get notified when your bids are accepted or rejected
                  </p>
                </div>
              </label>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
